<template>
  <b-container id="FeedbackScore">
    <b-row>
      <b-col>
        <div class="divider"></div>
        <p class="feedb_references">
          Feedback Scores
          <span class="dashboard_info_circle">
            <b-icon icon="info-circle" />
            <div class="hideInfoCircle">
              <p>
                <b>Survey questions are divided into four key skills.</b>
                Each survey answer has been assigned a proficiency scale.
                <strong> Strongly agree</strong>=100, <strong>Agree</strong>=80,
                <strong>Neutral</strong>=60, <strong>Disagree</strong>=40,
                <strong>Strongly disagree</strong>=20.
              </p>
              <b>{{ text_1 }} </b>
              <p>
                {{ text_2 }}
              </p>
              <p>
                <b>
                  {{ text_3 }}
                </b>
                {{ text_4 }}
              </p>
              <p v-if="text_5">
                <b v-if="text_6">{{ text_6 }}</b>
                {{ text_5 }}
              </p>
            </div>
          </span>
        </p>
        <b-row class="feedb_perc">
          <b-col cols="8">
            <p><span class="amazingly"> </span> Amazingly done!</p>
          </b-col>
          <b-col cols="4">
            <p>
              <b>86%-100%</b>
            </p>
          </b-col>
          <b-col cols="8">
            <p><span class="almostThere"> </span> Almost there</p>
          </b-col>
          <b-col cols="4">
            <p>
              <b>61% - 85%</b>
            </p>
          </b-col>
          <b-col cols="8">
            <p><span class="askForGuidance"> </span> Ask for guidance</p>
          </b-col>

          <b-col cols="4">
            <p>
              <b>41% - 60%</b>
            </p>
          </b-col>

          <b-col cols="8">
            <p><span class="timeToApply"> </span> Time to apply yourself</p>
          </b-col>
          <b-col cols="4">
            <p>
              <b>21% - 40%</b>
            </p>
          </b-col>

          <b-col cols="8">
            <p><span class="urgent"> </span> Urgent — ask for help</p>
          </b-col>
          <b-col cols="4">
            <p>
              <b>0% - 20%</b>
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "FeedbackScore",
  props: ["text_1", "text_2", "text_3", "text_4", "text_5", "text_6"],
};
</script>
<style lang="less">
@import "../../assets/components/common/FeedbackScore.less";
</style>